import {Grid, Avatar, Typography} from '@mui/material';
import {TestimonialComponentDTO} from '../../../../api/models';

export const TestimonialComponent = ({testimonial}: {testimonial: TestimonialComponentDTO}) => {
    return (
        <Grid style={{marginTop: 12}} container>
            <Grid item md={2} xs={2} sm={2} lg={2} xl={2}>
                <center>
                    <Avatar src={testimonial.displayImage.url} sx={{width: 64, height: 64}} />
                </center>
            </Grid>
            <Grid item md={10} xs={10} sm={10} lg={10} xl={10}>
                <Typography
                    sx={{
                        marginTop: 1,
                        fontWeight: 500,
                        color: 'black',
                        fontFamily: 'Poppins',
                    }}
                    variant='h6'>
                    {testimonial.displayName.text}
                </Typography>
                <Typography
                    sx={{
                        marginTop: 1,
                        fontWeight: 300,
                        color: 'black',
                        fontFamily: 'Poppins',
                    }}
                    variant='body1'>
                    {testimonial.feedbackContent.text}
                </Typography>
            </Grid>
        </Grid>
    );
};
